export default __webpack_public_path__ + "static/papc_banner-6396983463ab4a7e75ee197230fdcdf5.png";